import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import messages from './messages';
import OrderSummary from '../../Checkout/OrderSummary';
import OrderSummarySteppedWrapper from '../../Checkout/OrderSummarySteppedWrapper';
import { OrderSummaryDataSources } from '../../../hooks/useOrderDataSource';

const ItemsOnTheirWay = () => {
  const { formatMessage } = useIntl();
  const order = useSelector((state) => state.order);

  return (
    order.status === 'succeeded' && (
      <div>
        <OrderSummarySteppedWrapper
          dataSource={OrderSummaryDataSources.ORDER}
          title={formatMessage(messages.title)}
          isOrderConfirmationPage
          isSummaryOpenDefault
        >
          <OrderSummary
            dataSource={OrderSummaryDataSources.ORDER}
            isOrderConfirmationPage
          />
        </OrderSummarySteppedWrapper>
      </div>
    )
  );
};

export default ItemsOnTheirWay;
